import * as React from 'react';

import BoxDev16 from './BoxDev16';

export const boxDev16 = () => <BoxDev16 />;

export default {
    title: 'Icon/Line/BoxDev16',
    component: BoxDev16,
    parameters: {
        notes: "`import BoxDev16 from 'box-ui-elements/es/icon/line/BoxDev16';`",
    },
};
